import styled from 'styled-components';

export const ChatBodyContainer = styled.div`
  width: 100%;
  height: calc(100% - 40px);
`;
export const ChatBodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ChatBodyMessageContainer = styled.div`
  width: 100%;
  background: #f9f9f9;
  padding: 10px 10px 10px 10px;
  box-sizing: border-box;
  overflow-x: hidden;
  flex: 1;
  overflow-y: auto;
  scroll-behavior: auto;

  scrollbar-width: none; /* 去掉水平滚动条 */
  -ms-overflow-style: none; /* 去掉IE和Edge的垂直滚动条 */

  ::-webkit-scrollbar {
    display: none; /* 去掉Chrome、Safari和Opera的滚动条 */
  }
`;
export const ChatBodyOperationContainer = styled.div`
  background: #ffffff;
`;

export const ChatBodyInputContainer = styled.div`
  width: 100%;
  height: 130px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
`;
export const ChatBodyButtonContainer = styled.div`
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
`;

export const ChatBodyEndContainer = styled.div`
  width: 100%;
  padding: 0 20px 20px 20px;
  box-sizing: border-box;
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const EvaluationIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    //width: 44px;
    //height: 44px;
    padding: 10px 0;
  }
`;
export const EvaluationText = styled.div`
  text-align: center;
  font-size: 14px;
  color: #999999;
`;
export const EvaluationButton = styled.div`
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #ffffff;
  background: ${(props) => props.$themecolor ?? '#3F5773'};
  font-size: 14px;
  cursor: pointer;
  //width: 96px;
  padding: 0 14px;
  height: 28px;
`;

export const EndButton = styled.div`
  background: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  font-size: 14px;
  cursor: pointer;
  color: #666666;
`;
export const VideoButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  font-size: 14px;
  cursor: pointer;
  color: #ffffff;
  background: ${(props) => props.$themecolor ?? '#3F5773'};
`;
export const DisableMask = styled.div`
  position: absolute;
  z-index: 9999;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: rgba(239, 239, 239, 0.8);
  cursor: not-allowed;
`;
export const LoadingTextBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  padding-bottom: 10px;
  > div {
    background: ${(props) => props.$chatservicecolor ?? '#F5EFF8'};
    padding: 4px;
    border-radius: 4px;
    font-size: 12px;
    color: #333333;
  }
`;

export const GuideQuestionContainer = styled.div`
  background-color: #f9f9f9;
  padding: 1px 10px 0 10px;
`;
export const GuideQuestionTitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  padding-bottom: 2px;
`;

export const CarouselItemWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 2px 0 6px 0;
`;

export const CarouselItem = styled.div`
  display: inline-block;
  border-radius: 12px;
  border: 1px solid #e0d6ff;
  background: linear-gradient(0deg, rgba(224, 214, 255, 0.1) 0%, rgba(224, 214, 255, 0.1) 100%), #fff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
  padding: 4px 8px 4px 10px;
  color: #333;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;

  cursor: pointer;
`;
export const ChatButton = styled.div`
  background-color: #f9f9f9;
  min-height: ${(props) => (props.$device == 'mobile' ? '50px' : '30px')};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  padding: 0 5px;
`;
export const ChatButtonItem = styled.div`
  cursor: ${(props) => (props.$device == 'mobile' ? 'none' : 'pointer')};
  padding: 0px 8px;
  height: ${(props) => (props.$device == 'mobile' ? '35px' : '22px')};
  border-radius: 4px;
  border: 1px solid #fff;
  background: linear-gradient(
      0deg,
      rgba(${(props) => props.$themecolor}, 0.05) 0%,
      rgba(${(props) => props.$themecolor}, 0.05) 100%
    ),
    #fff;
  box-shadow: 0px 1px 3px 0px rgba(${(props) => props.$themecolor}, 0.5);
  margin: 0px 5px 0 5px;
  flex: 0 0 auto;
  font-size: ${(props) => (props.$device == 'mobile' ? '16px' : '12px')};
  line-height: ${(props) => (props.$device == 'mobile' ? '35px' : '22px')};
  color: #333;
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: ${(props) => (props.$device == 'mobile' ? 'none' : 'scale(1.08)')};
    transition: transform 0.3s ease-in-out;
  }
`;
